import { render, staticRenderFns } from "./WorkflowFormDatePicker.vue?vue&type=template&id=126f1d3e&"
import script from "./WorkflowFormDatePicker.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormDatePicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports